import { c as _c } from "react/compiler-runtime";
import useCustomEvent from 'hooks/useCustomEvent';
import AllOptions, { ALL_OPTION_UPDATED_EVENT_TYPE } from './AllOptions';
const useAllOptionsOld = t0 => {
  const $ = _c(7);
  const skip = t0 === undefined ? false : t0;
  let t1;
  if ($[0] !== skip) {
    t1 = AllOptions.getAllOptions(skip);
    $[0] = skip;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [allOptionsLoading, allOptionsValues, allOptionsByValuesKey] = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      type: ALL_OPTION_UPDATED_EVENT_TYPE
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useCustomEvent(t2);
  let t3;
  if ($[3] !== allOptionsByValuesKey || $[4] !== allOptionsLoading || $[5] !== allOptionsValues) {
    t3 = {
      loading: allOptionsLoading,
      error: null,
      allOptionsValues,
      allOptionsByValuesKey
    };
    $[3] = allOptionsByValuesKey;
    $[4] = allOptionsLoading;
    $[5] = allOptionsValues;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default useAllOptionsOld;